import { calculateCompoundRewards } from '../utils'

export const useCalculateRewards = (amount: number, apyRate: number) => {
  const rewardsData = calculateCompoundRewards(amount, apyRate)

  return {
    rewardsData,
  }
}
